// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface ISourceSystemType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class SourceSystemType implements ISourceSystemType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Customer SourceSystemType
	**/
    get Customer(): ISourceSystemType {
        return this.FromId(1);
    }
    /**
		Returns Finance SourceSystemType
	**/
    get Finance(): ISourceSystemType {
        return this.FromId(2);
    }
    /**
		Returns TitleRegistration SourceSystemType
	**/
    get TitleRegistration(): ISourceSystemType {
        return this.FromId(3);
    }
    /**
		Returns Driver SourceSystemType
	**/
    get Driver(): ISourceSystemType {
        return this.FromId(4);
    }
    /**
		Returns OIG SourceSystemType
	**/
    get OIG(): ISourceSystemType {
        return this.FromId(5);
    }
    /**
		Returns License and Contracting SourceSystemType
	**/
    get LicenseandContracting(): ISourceSystemType {
        return this.FromId(6);
    }
    /**
		Returns PACE SourceSystemType
	**/
    get PACE(): ISourceSystemType {
        return this.FromId(7);
    }
    /**
		Returns Help Desk SourceSystemType
	**/
    get HelpDesk(): ISourceSystemType {
        return this.FromId(8);
    }
    /**
		Returns Case SourceSystemType
	**/
    get Case(): ISourceSystemType {
        return this.FromId(9);
    }
    /**
		Returns Collections SourceSystemType
	**/
    get Collections(): ISourceSystemType {
        return this.FromId(10);
    }
    /**
		Returns IRP SourceSystemType
	**/
    get IRP(): ISourceSystemType {
        return this.FromId(11);
    }
    /**
		Returns Commercial Permitting SourceSystemType
	**/
    get CommercialPermitting(): ISourceSystemType {
        return this.FromId(12);
    }
    /**
		Returns Dealer License SourceSystemType
	**/
    get DealerLicense(): ISourceSystemType {
        return this.FromId(13);
    }
    /**
		Returns Aircraft SourceSystemType
	**/
    get Aircraft(): ISourceSystemType {
        return this.FromId(14);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'Customer', displayValue: 'Customer', description: 'Customer', sortOrder: 1, active: true });
        this._dictionary.add('2', { id: 2, value: 'Finance', displayValue: 'Finance', description: 'Finance', sortOrder: 2, active: true });
        this._dictionary.add('3', { id: 3, value: 'TitleRegistration', displayValue: 'TitleRegistration', description: 'TitleRegistration', sortOrder: 3, active: true });
        this._dictionary.add('4', { id: 4, value: 'Driver', displayValue: 'Driver', description: 'Driver', sortOrder: 4, active: true });
        this._dictionary.add('5', { id: 5, value: 'OIG', displayValue: 'OIG', description: 'OIG', sortOrder: 5, active: true });
        this._dictionary.add('6', { id: 6, value: 'LicenseandContracting', displayValue: 'License and Contracting', description: 'License and Contracting', sortOrder: 6, active: true });
        this._dictionary.add('7', { id: 7, value: 'PACE', displayValue: 'PACE', description: 'Prohibition And Compliance Engine', sortOrder: 99999, active: true });
        this._dictionary.add('8', { id: 8, value: 'HelpDesk', displayValue: 'Help Desk', description: 'Help Desk', sortOrder: 99999, active: true });
        this._dictionary.add('9', { id: 9, value: 'Case', displayValue: 'Case', description: 'Case', sortOrder: 99999, active: true });
        this._dictionary.add('10', { id: 10, value: 'Collections', displayValue: 'Collections', description: 'Collections', sortOrder: 99999, active: true });
        this._dictionary.add('11', { id: 11, value: 'IRP', displayValue: 'IRP', description: 'IRP', sortOrder: 99999, active: true });
        this._dictionary.add('12', { id: 12, value: 'CommercialPermitting', displayValue: 'Commercial Permitting', description: 'Commercial Permitting', sortOrder: 99999, active: true });
        this._dictionary.add('13', { id: 13, value: 'DealerLicense', displayValue: 'Dealer License', description: 'Dealer License', sortOrder: 99999, active: true });
        this._dictionary.add('14', { id: 14, value: 'Aircraft', displayValue: 'Aircraft', description: 'Aircraft', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ISourceSystemType {
        return this._dictionary[id];
    }

    public FromValue(value: string): ISourceSystemType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ISourceSystemType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ISourceSystemType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): ISourceSystemType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
